const {registerModule, KitModule} = window;

class Partners extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
    this.bindObserver();
  }

  setVars() {
    this.observer = null;
    this.options = {
      rootMargin: '0px',
      threshold: 0,
    };
  }

  bindEvents() {
    // On types click switch classes base on index
    this.$type.forEach(($type) => {
      $type.addEventListener('click', this);
    });
  }

  bindObserver() {
    this.observer = new IntersectionObserver(this.observerCallback.bind(this), this.options);
    this.observer.observe(this.$element);
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const media = this.$partner[0].querySelector('.js-video');
        this.reloadMedia(media);
      }
    });
  }

  onclick(e) {
    const target = e.currentTarget;
    const index = target.getAttribute('data-index');
    const media = this.$partner[index - 1].querySelector('.js-video');

    this.updateElementClasses(this.$type, 'type', index);
    this.updateElementClasses(this.$partner, 'partner', index);

    this.reloadMedia(media);
  }

  updateElementClasses(elements, name, index) {
    elements.forEach(($el) => {
      $el.classList.remove(`${name}--is-active`);
    });
    elements[index - 1].classList.add(`${name}--is-active`);
  }

  async reloadMedia(media) {
    if (media) {
      const video = media.querySelector('video');
      video.pause();
      video.currentTime = 0;

      try {
        await video.play();
      } catch (error) {
        console.error(error);
      }
    }
  }
}

registerModule('Partners', Partners);
